// Phiếu kế toán hợp nhất (đợt 5, TH-00 mục 6.2): một bộ nhóm lọc trên VIEW GLVoucher, dựng thành nhiều pack chỉ khác
// nhóm mở sẵn (kit không đọc nhóm từ URL; trang chọn pack theo ?group=) và có / không nhóm Theo phiếu mẫu.
const TEXT = {
    Pending: { vi: 'Chờ ghi sổ', en: 'Pending Postings', fr: 'Écritures en attente', es: 'Asientos pendientes', id: 'Posting tertunda', ja: '転記待ち', zh: '待过账', ko: '전기 대기', hi: 'लंबित पोस्टिंग', ar: 'الترحيل المعلق' },
    Template: { vi: 'Theo mẫu', en: 'By Template', fr: 'Par modèle', es: 'Por plantilla', id: 'Per template', ja: 'テンプレート別', zh: '按模板', ko: '템플릿별', hi: 'टेम्पलेट से', ar: 'حسب القالب' },
    Posted: { vi: 'Đã ghi sổ', en: 'Posted', fr: 'Comptabilisé', es: 'Registrado', id: 'Diposting', ja: '転記済', zh: '已过账', ko: '전기됨', hi: 'पोस्ट किया गया', ar: 'مُرحّل' },
    Error: { vi: 'Lỗi', en: 'Error', fr: 'Erreur', es: 'Error', id: 'Galat', ja: 'エラー', zh: '错误', ko: '오류', hi: 'त्रुटि', ar: 'خطأ' },
    ErrorSystem: { vi: 'Hệ thống kiểm tra', en: 'System check', fr: 'Contrôle système', es: 'Control del sistema', id: 'Pemeriksaan sistem', ja: 'システムチェック', zh: '系统检查', ko: '시스템 검사', hi: 'सिस्टम जाँच', ar: 'فحص النظام' },
    ErrorUser: { vi: 'Kế toán từ chối', en: 'Rejected by accountant', fr: 'Refusé par le comptable', es: 'Rechazado por contador', id: 'Ditolak akuntan', ja: '担当者が却下', zh: '会计拒绝', ko: '담당자 거부', hi: 'लेखाकार द्वारा अस्वीकृत', ar: 'رفض المحاسب' },
    ErrorGenerate: { vi: 'Lỗi tạo bút toán', en: 'Posting Errors', fr: "Erreurs d'écriture", es: 'Errores de asiento', id: 'Kesalahan posting', ja: '仕訳作成エラー', zh: '分录生成错误', ko: '분개 생성 오류', hi: 'प्रविष्टि त्रुटियाँ', ar: 'أخطاء القيود' }
};

// Nhóm Theo phiếu mẫu chỉ có nghĩa khi có phân hệ ERP sinh phiếu hàng loạt (khớp BusinessFeatures GL_use_post_template).
const ERP_MODULES = { use_Module_AR: 1, use_Module_AP: 1, use_Module_IC: 1, use_Module_MF: 1, use_Module_HRM: 1, use_Module_CRM: 1 };

const GROUPS = [
    { name: 'Pending', searchConditions: { ledger_status: 'Pending' } },
    { name: 'Template', searchConditions: { ledger_status: 'Pending', template_id: 'NotNull' }, visible: { whenSys: ERP_MODULES, whenSysType: 'OR' }, template: true },
    { name: 'Posted', searchConditions: { ledger_status: 'Posted' } },
    { name: 'Error', searchConditions: { ledger_status: 'Error' } },
    { name: 'ErrorSystem', searchConditions: { source_table: 'PNLJournal', journal_status: 'Rejected', reject_source: 'System' } },
    { name: 'ErrorUser', searchConditions: { source_table: 'PNLJournal', journal_status: 'Rejected', reject_source: ['User', 'VoucherDeleted'] } },
    { name: 'ErrorGenerate', searchConditions: { source_table: 'PNLPostingRetry' } }
];

export const GL_VOUCHER_GROUPS = ['Pending', 'Posted', 'Error'];

export function glVoucherPackName(group, withTemplate) {
    const base = group === 'Posted' ? 'GLVoucherPosted' : group === 'Error' ? 'GLVoucherError' : 'GLVoucher';
    return withTemplate ? base : base + 'NoTemplate';
}

export function buildGLVoucherGroups(defaultGroup, withTemplate) {
    return GROUPS.filter((group) => withTemplate || !group.template).map(({ template, ...group }) => ({
        ...group,
        text: TEXT[group.name],
        ...(group.name === defaultGroup ? { default: true } : {})
    }));
}

const packs = [];
for (const group of GL_VOUCHER_GROUPS) {
    for (const withTemplate of [true, false]) packs.push({ name: glVoucherPackName(group, withTemplate), value: buildGLVoucherGroups(group, withTemplate) });
}

export default packs;
